import React from 'react';
import useLabels from '@/lib/hooks/swr/useLabels';

const usePreselectedLabels = (labelIds = [], swrOptions) => {
  const labelIdString = labelIds.join(',').trim();
  const searchParams = React.useMemo(
    () => (labelIdString ? { labelIds: labelIdString } : null),
    [labelIdString],
  );
  return useLabels(searchParams, swrOptions);
};

export default usePreselectedLabels;
